import './styles/index.less';

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import modules from 'js/modules/index';
import pages from 'js/pages/index';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min';
import 'js/plugins/daterangepicker.min';
import 'js/plugins/jquery.inputmask.min';
import moment from 'moment';

(function(){
  moment.locale(window.Globals.language);
  modules();
  pages();

  $('.js-phone-mask').inputmask('(599) 999 99 99');
  $('.js-card-mask').inputmask('9999 9999 9999 9999');
  $('.js-cvv-mask').inputmask('999');
  $('.js-card-skt-mask').inputmask('99/99');
  $('.js-tckimlik-mask').inputmask('99999999999');
  $('.js-vergino-mask').inputmask('9999999999');
  $('.js-birthday-mask').inputmask('99/99/9999');

  $(document).on('click', 'a[href="#"]', (e) => {
    e.preventDefault();
  });

  $('[data-toggle="tooltip"]').tooltip({
    animation: false
  });
}())


/** WEBPACK FOOTER **
 ** ./assets/index.js
 **/